<script setup>
import { Link } from '@inertiajs/vue3';

defineProps({
  href: String,
  as: String,
  classes: {
    type: String,
    default: ''
  }
});
</script>

<template>
  <div>
    <button
      v-if="as === 'button'"
      :class="classes"
      type="submit"
      class="hover:bg-white-500 focus:bg-primary-500 block w-full px-4 py-2 text-start text-sm leading-5 transition duration-150 ease-in-out focus:text-white md:px-8 md:py-4"
    >
      <slot />
    </button>

    <a
      v-else-if="as === 'a'"
      :class="classes"
      :href="href"
      class="hover:bg-white-500 focus:bg-primary-500 block px-4 py-2 text-sm leading-5 text-nowrap transition duration-150 ease-in-out focus:text-white md:px-8 md:py-4"
    >
      <slot />
    </a>

    <Link
      v-else
      prefetch
      :class="classes"
      :href="href"
      class="hover:bg-nav-item block px-4 py-2 font-normal text-nowrap transition duration-150 ease-in-out md:px-8 md:py-4"
    >
      <slot />
    </Link>
  </div>
</template>
